import React, { useState } from "react";
import "./style.scss";
import moment from "moment";
import EditIcon from "../../assets/images/icons/edit";
import DeleteIcon from "../../assets/images/icons/delete";
import InfiniteScroll from 'react-infinite-scroller';

const TaskColumn = ({
  title,
  status_id,
  type,
  data,
  pagination,
  className,
  handleSelectTask,
  handleDeleteTask,
  handleActiveViewMode,
  handleGetTasks,
}) => {

  const [myPage, setMyPage] = useState(1);
  
  if (!data) return null

  const loadFunc = (page) => {
    setMyPage(page);
    handleGetTasks(page, status_id);
  }

  // console.log(pagination)

  return (
    <div className={`${className} `}>
      <div className={"col-12 task-col p-3"}>
        <div className="mb-4">{title}</div>
        <div className="scrollbar scrollbar-custom " id="style-4" >
              <InfiniteScroll
                  pageStart={1}
                  loadMore={(page) => loadFunc(page)}
                  hasMore={myPage < pagination?.last_page}
                  loader={<div className="loader" key={0}>Loading ...</div>}
                  useWindow={false}
              >
                  {data?.map((task, i) => (
                    <div  key={i}
                          className={`task-card mb-2 ${
                            task?.status_id === 1
                              ? "task-new"
                              : task?.status_id === 2 || task?.status_id === 3
                              ? "task-inprogress"
                              : task?.status_id === 4 || task?.status_id === 5
                              ? "task-completed"
                              : ""
                          }
                          ${
                            //in progress delay
                            task?.status_id === 3 && moment(task?.complete_date).diff(moment(), "days") ? "task-inprogress-day"
                            : task?.status_id === 3 && moment(task?.complete_date).diff(moment(), "minutes") ? "task-inprogress-hour"
                            : ""
                          }
                          padding-10`}
                          onClick={() => handleActiveViewMode(task)}
                        >
                      <div className="icons">
                        {task?.status_id === 1 && (
                          <button className='delete-icon'  onClick={(e) => {
                                              e.stopPropagation();
                                            // e.preventDefault();
                                              handleDeleteTask(task)
                                            }}>
                              <DeleteIcon className={"cursor-pointer"} />
                          </button>
                        )}
                        {(task?.status_id === 1 ||
                          task?.status_id === 2 ||
                          task?.status_id === 3) && (
                          <button className='edit-icon' onClick={(e) => {
                                              e.stopPropagation();
                                            // e.preventDefault();
                                              handleSelectTask(task)
                                            }}>
                              <EditIcon className={"cursor-pointer"} />
                          </button>
                        )}
                      </div>

                      <p className={"gray-color"} style={{ marginBottom: '10px' }}>
                        {moment(task?.complete_date).format("dddd,\xa0 DD MMMM YYYY, h:mm a")}
                      </p>

                      {/* {task?.history?.map((history, i) => 
                        history?.status_id === task?.status_id && (
                          //show date of history of current status
                            <p key={i} className={"gray-color"}>
                              {moment(task?.complete_date).format(
                                "dddd,\xa0 DD MMMM YYYY, h:mm a"
                              )}
                            </p>
                      ))} */}
                      <p className={"mb-0 truncate-three-lines"}>{task?.description}</p>
                    </div>
                  ))}
              </InfiniteScroll>
        </div>
      </div>
    </div>
  );
};

export default TaskColumn;
